
























































import { ProductRecommendationView } from "@zoovu/runner-web-design-base";
import { InjectComponent, VueComponent, Prop } from "@zoovu/runner-browser-api";

export default class ProductRecommendationViewExtended extends ProductRecommendationView {
  @InjectComponent("ProductPriceView")
  productPriceView: VueComponent;

  @Prop({ default: false })
  isBundle!: boolean;
}
